'use client';

import { MascotWithName } from '@spikemark/ui/components/mascot-with-name';
import { PlayerLink, TeamLink } from '@spikemark/ui/components/navigation/entity-links';
import { Button } from '@spikemark/ui/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@spikemark/ui/components/ui/dialog';
import { FC, useCallback } from 'react';
import { SchoolWithPlayers } from './participants';
import { OverallRankDisplay } from '@spikemark/ui/components/table/leaderboard/columns/shared';
export const TeamPlayersDialog: FC<{
  open: boolean;
  school?: SchoolWithPlayers;
  onClose: () => void;
  rankingsEnabled?: boolean;
}> = ({
  open,
  onClose,
  school,
  rankingsEnabled
}) => {
  const handleOpenChange = useCallback((open: boolean) => {
    if (!open) {
      onClose();
    }
  }, [onClose]);
  const hasMultipleTeams = school?.players?.find(player => player.teamLabel && !['A', 'IND'].includes(player.teamLabel));
  return <Dialog open={open} modal onOpenChange={handleOpenChange} data-sentry-element="Dialog" data-sentry-component="TeamPlayersDialog" data-sentry-source-file="team-players-dialog.tsx">
      <DialogContent compact className="lg:max-w-xl" data-sentry-element="DialogContent" data-sentry-source-file="team-players-dialog.tsx">
        {school && <DialogHeader className="justify-between flex-col items-start lg:items-center lg:flex-row" compact>
            <MascotWithName alt={school?.boardName!} variant="medium" path={school?.schoolLogo} displayMode="team">
              <DialogTitle>{school?.boardName}</DialogTitle>
              <p className="text-base text-gray-500">{school?.players?.length} Players</p>
            </MascotWithName>
            <div className="self-end">
              <Button variant="outline" asChild>
                <TeamLink schoolId={school?.schoolId!}>View Team Profile</TeamLink>
              </Button>
            </div>
          </DialogHeader>}
        <ul className="overflow-y-auto flex-1 mb-6 lg:max-h-1/2-screen">
          {school?.players?.map(player => <li key={player.playerId} className="px-6 py-2 flex items-center justify-between odd:bg-gray-50">
              <MascotWithName variant="medium" alt={player.playerName} path={player.userPicture} displayMode="player">
                <PlayerLink className="font-bold" playerId={player.playerId}>
                  {player.playerName}
                </PlayerLink>
                <p className="text-sm text-secondary">
                  {player.teamLabel == 'IND' ? 'IND' : (hasMultipleTeams ? `(${player.teamLabel}) ` : '') + `Player #${player.playerSeed}${player.isSubstitute ? ' (SUB)' : ' '}`}
                  {player.schoolYear ? `, ${player.schoolYear}` : ''}
                </p>
              </MascotWithName>
              {rankingsEnabled && <OverallRankDisplay overallRank={player.rank} variant="simple" />}
            </li>)}
        </ul>
      </DialogContent>
    </Dialog>;
};